import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import LoginButton from "../../buttons/LoginButton";
import LogoutButton from "../../buttons/LogoutButton";
import SignupButton from "../../buttons/SignupButton";

const MobileNavBarButtons = () => {
    const { isAuthenticated } = useAuth0();

    return (
        <div className="mobile-nav-bar__buttons">
            {!isAuthenticated && (
                <>
                    <SignupButton />
                    <LoginButton />
                </>
            )}
            {isAuthenticated && (
                <>
                    <LogoutButton />
                </>
            )}
        </div>
    );
};

export default MobileNavBarButtons;
